import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { RichTextEditor } from "common/richTextEditorSyncFusion/RichTextEditor";
export interface IFormRedirectionPageProps {
  header: string;
  message: string | undefined | null;
  redirectUrl?: string | null;
}
export const FormRedirectionPage: React.FC<IFormRedirectionPageProps> = ({
  header,
  message,
  redirectUrl,
}) => {
  const { t: translate } = useTranslation("form_builder");
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: (theme) => theme.palette.background.lightBlue,
      }}
    >
      <Box
        sx={{
          width: { xs: "100%", md: "50%" },
          background: (theme) => theme.palette.common.white,
          p: 4,
        }}
      >
        <Typography variant="h4" sx={{ color: "text.primary" }}>
          {header}
        </Typography>
        {message && (
          <Box sx={{ mt: 2 }}>
            <RichTextEditor value={message} isPreviewMode />
          </Box>
        )}
        {redirectUrl && (
          <Typography mt={4}>
            {translate("forms.confirmation.redirect_message")}{" "}
            <a href={redirectUrl}>{redirectUrl}</a>.
          </Typography>
        )}
        <Box
          sx={{
            mt: 4,
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="caption" color="grey.900">
            {translate("forms.confirmation.nexl_branding")}{" "}
            <a href="https://nexl.cloud/">Nexl</a>{" "}
            {translate("forms.confirmation.learn_more")}.
          </Typography>
          <img height={16} src="/images/nexl_logo.svg" alt="go to home" />
        </Box>
      </Box>
    </Box>
  );
};
